export enum CashOccurrenceType {
    RECURRING,
    ONE_OFF,
}
